import React from 'react';
import kebab from '../assets/illustration-webp/kebab-1.webp';
import dizio from '../assets/illustration-webp/dexter.webp';
import marlone from '../assets/illustration-webp/marlone.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter, faInstagram, faTiktok, faYoutube} from "@fortawesome/free-brands-svg-icons";

const Labs = () => {
  return (
    <section className="labs mt-10">
        <div className="container mx-auto px-6">

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 md:grid-cols-3 gap-8">
                <div className="bg-neutral-900 rounded-lg shadow-lg p-6">
                    <img
                    src= {dizio}
                    alt="Dizio"
                    className="w-32 h-32 object-cover rounded-full mx-auto mb-4"
                    data-aos="fade-right" 
                    data-aos-anchor-placement="center-bottom"
                    />
                    <h3 className="text-2xl font-semibold mb-2 text-[#be185d] text-center"
                    data-aos="fade-down" data-aos-anchor-placement="bottom-bottom" data-aos-offset="100">Dizio</h3>
                    <p className="job text-gray-300 text-center italic">
                    Ingénieur R&D
                    </p>
                    <p className=" text-gray-300 text-left mt-4">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam recusandae expedita amet? Reiciendis, quae adipisci. Exercitationem doloribus inventore cumque veritatis repellendus dolores quibusdam? Voluptas vel repellat, sed cupiditate commodi dolor.
                    </p>
                    <div className='labs-socials mt-6'>
                        <a href="https://x.com/DizioTech" target=''><FontAwesomeIcon icon={faXTwitter}/></a>
                    </div>
                </div>
                <div className="bg-neutral-900 rounded-lg shadow-lg p-6">
                    <img
                    src= {kebab}
                    alt="Kebab"
                    className="w-32 h-32 object-cover rounded-full mx-auto mb-4"
                    data-aos="fade-right" 
                    data-aos-anchor-placement="center-bottom"
                    />
                    <h3 className="text-2xl font-semibold mb-2 text-[#be185d] text-center"
                    data-aos="fade-down" data-aos-anchor-placement="bottom-bottom" data-aos-offset="100">Kebab</h3>
                    <p className="job text-gray-300 text-center italic">
                        Artiste 3D et CM
                    </p>
                    <p className="text-gray-300 text-left mt-4">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam recusandae expedita amet? Reiciendis, quae adipisci. Exercitationem doloribus inventore cumque veritatis repellendus dolores quibusdam? Voluptas vel repellat, sed cupiditate commodi dolor.
                    </p>
                    <div className='labs-socials mt-6'>
                        <a href="https://x.com/Kebabgang1" target=''><FontAwesomeIcon icon={faXTwitter}/></a>
                    </div>
                </div>
                <div className="bg-neutral-900 rounded-lg shadow-lg p-6">
                    <img
                    src= {marlone}
                    alt="Marlone"
                    className="w-32 h-32 object-cover rounded-full mx-auto mb-4"
                    data-aos="fade-right" 
                    data-aos-anchor-placement="center-bottom"
                    />
                    <h3 className="text-2xl font-semibold mb-2 text-[#be185d] text-center"
                    data-aos="fade-down" data-aos-anchor-placement="bottom-bottom" data-aos-offset="100">Marlone</h3>
                    <p className="job text-gray-300 text-center italic">
                        Creative Mind COO
                    </p>
                    <p className="text-gray-300 text-left mt-4">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam recusandae expedita amet? Reiciendis, quae adipisci. Exercitationem doloribus inventore cumque veritatis repellendus dolores quibusdam? Voluptas vel repellat, sed cupiditate commodi dolor.
                    </p>
                    <div className='labs-socials mt-6'>
                        <a href="https://x.com/Marlone_b" target=''><FontAwesomeIcon icon={faXTwitter}/></a>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Labs